import React, { useState, useEffect, useContext, Suspense, use } from "react";
import { connect } from "react-redux";
import { Button, Row } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";

import Select from "react-select";
import CustomSelectInput from "../../components/common/CustomSelectInput";

import IntlMessages from "../../utils/IntlMessages";
import { LayoutContext } from "../../layouts/UserLayout";
import { getOfficeUsersDropdown, getOfficeUsersMenu, updateInvoiceMenu } from "../../redux/admin/Users/action";
import MenuPermissionRow from "./MenuPermissionRow";
import { getInvoiceMenus } from "../../redux/admin/Users/action";



const UserMenus = ({ users, getOfficeUsersDropdown, getOfficeUsersMenu, office_user_menus, updateInvoiceMenu,invoice_menus,getInvoiceMenus, menuId }) => {

  const menus = invoice_menus || [];
  const { setPageTitle } = useContext(LayoutContext);
  const defaultOption = {
    value: "",
    label: "Select"
  };

  const [userData, setUserData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(defaultOption);
  const [permissions, setPermissions] = useState({});
  const [errorMeesage, setErrorMeesage] = useState('');

  useEffect(() => {
    getOfficeUsersDropdown()
    getInvoiceMenus(); 
  }, [])

  useEffect(() => {
    let data = [];
    if (users?.length > 0) {
      data = users.map((item, index) => {
        return {
          key: index,
          value: item.user_id,
          label:
            item.full_name + " - " + item.user_name
        };
      });
    }

    const options = [defaultOption, ...data];
    setUserData(options);
    setSelectedUser(defaultOption); // select "Select" by default

  }, [users])

  useEffect(() => {
    setPageTitle(<IntlMessages id={menuId} />);

    return () => setPageTitle("");
  }, [setPageTitle]);

  useEffect(() => {

    if (selectedUser?.value) {
      getOfficeUsersMenu({ userID: selectedUser?.value })
    } else {
      setPermissions([]);
    }

  }, [selectedUser])

  useEffect(() => {
    const permissionMap = buildPermissionState(office_user_menus?.length ? office_user_menus : []);
    setPermissions(permissionMap);
  }, [office_user_menus])


  const updatePermission = (menu, value) => {
    setPermissions(prev => {
      const updated = { ...prev };
      const oldValue = prev[menu.id] || {};

      // Detect which permission changed
      const changedPermissions = {};
      ['canRead', 'canWrite', 'canDelete', 'canPrint'].forEach(perm => {
        if (oldValue[perm] !== value[perm]) {
          changedPermissions[perm] = value[perm];
        }
      });

      applyToChildren(menu, value, updated, changedPermissions);
      applyToParents(menu, value, updated);
      return updated;
    });
  };

  const applyToChildren = (menu, value, updated, changedPermissions = null) => {
    updated[menu.id] = value;

    menu.children?.forEach(child => {
      if (changedPermissions) {
        // Only apply the changed permissions, preserve others
        const childPerms = updated[child.id] || {
          canRead: false,
          canWrite: false,
          canDelete: false,
          canPrint: false
        };

        const newChildPerms = { ...childPerms };

        // Apply only the changed permissions
        Object.keys(changedPermissions).forEach(perm => {
          newChildPerms[perm] = changedPermissions[perm];

          // If disabling canRead, disable all permissions
          if (perm === 'canRead' && !changedPermissions[perm]) {
            newChildPerms.canWrite = false;
            newChildPerms.canDelete = false;
            newChildPerms.canPrint = false;
          }
        });

        applyToChildren(child, newChildPerms, updated, changedPermissions);
      } else {
        // Original behavior: apply all permissions
        applyToChildren(child, value, updated);
      }
    });
  };

  const applyToParents = (menu, value, updated) => {
    // Find parent menu by checking if any menu has this menu as a child
    const findParent = (currentMenu, targetId, allMenus) => {
      for (const m of allMenus) {
        if (m.children?.some(child => child.id === targetId)) {
          return m;
        }
        if (m.children) {
          const found = findParent(m, targetId, m.children);
          if (found) return found;
        }
      }
      return null;
    };

    const parent = findParent(null, menu.id, menus);

    if (parent) {
      // Get current parent permissions
      const parentPerms = updated[parent.id] || {
        canRead: false,
        canWrite: false,
        canDelete: false,
        canPrint: false
      };

      // Check all siblings (including current menu) to determine parent permissions
      const newParentPerms = { ...parentPerms };

      // For each permission type, check if ANY child has it enabled
      const permissionTypes = ['canRead', 'canWrite', 'canDelete', 'canPrint'];

      permissionTypes.forEach(permType => {
        // If child is enabling this permission, enable parent
        if (value[permType]) {
          newParentPerms[permType] = true;
        } else {
          // If child is disabling, check if any sibling still has it
          const anyChildHasPermission = parent.children?.some(child => {
            const childPerms = updated[child.id] || {};
            return childPerms[permType] === true;
          });

          // Only disable parent if NO children have this permission
          if (!anyChildHasPermission) {
            newParentPerms[permType] = false;
          }
        }
      });

      updated[parent.id] = newParentPerms;

      // Recursively apply to grandparents
      applyToParents(parent, newParentPerms, updated);
    }
  };

  const savePermissions = async () => {

    if (selectedUser?.value) {
      updateInvoiceMenu({ menus: permissions, userID: selectedUser?.value })
    }
    setErrorMeesage(selectedUser?.value ? '' : 'Please choose user')
  };


  const buildPermissionState = (menus, result = {}) => {
    menus.forEach(menu => {
      result[menu.id] = {
        canRead: !!menu.permissions?.canRead,
        canWrite: !!menu.permissions?.canWrite,
        canDelete: !!menu.permissions?.canDelete,
        canPrint: !!menu.permissions?.canPrint
      };

      if (menu.children?.length) {
        buildPermissionState(menu.children, result);
      }
    });

    return result;
  };



  return (
    <div className="p-1 p-md-3">
      <div className="card shadow-sm mt-3">
        <Row className="justify-content-md-center m-3 align-items-center">

          <Colxx md="4">
            <label><IntlMessages id="username" /></label>
            <Select
              components={{ Input: CustomSelectInput }}
              className="react-select"
              classNamePrefix="react-select"
              name="userid"
              options={userData}
              value={selectedUser}
              onChange={(val) => setSelectedUser(val)}
            />
            <span className={`error-message`} >{errorMeesage ? 'Please select user' : ''}</span>
          </Colxx>
          <Colxx md="4" className={selectedUser?.error ? `mt-2` : `mt-4`}>
            <button type="submit" className="btn btn-outline-primary" onClick={savePermissions}>Save</button>
          </Colxx>

        </Row>
        <Row>
          <Colxx>
            <div className="permission-container">
              <table className="permission-table table-scroll">
                <thead>
                  <tr>
                    <th>Menu</th>
                    <th>
                      <span>
                        R-Read
                        W-Write
                        D-Delete
                        P-PDF Option
                      </span>



                    </th>
                  </tr>
                </thead>
                <tbody>
                  {menus.map(menu => (
                    <MenuPermissionRow
                      key={menu.id}
                      menu={menu}
                      permissions={permissions}
                      onChange={updatePermission}
                    />
                  ))}
                </tbody>
              </table>

            </div>
          </Colxx>
        </Row>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  users: state.users.dropdown_officer_users,
  office_user_menus: state.users.office_user_menus,
   invoice_menus: state.users.invoice_menus,
});


export default connect(mapStateToProps, { getOfficeUsersDropdown, getOfficeUsersMenu, updateInvoiceMenu,getInvoiceMenus })(UserMenus);

